module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Profile Picture\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "image content"
  }, [_c('div', {
    staticClass: "ui medium image"
  }, [_c('img', {
    attrs: {
      "src": "https://semantic-ui.com/images/avatar2/large/rachel.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("We've auto-chosen a profile image for you.")]), _vm._v(" "), _c('p', [_vm._v("We've grabbed the following image from the "), _c('a', {
    attrs: {
      "href": "https://www.gravatar.com",
      "target": "_blank"
    }
  }, [_vm._v("gravatar")]), _vm._v(" image associated with your registered e-mail address.")]), _vm._v(" "), _c('p', [_vm._v("Is it okay to use this photo?")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("\n      Nope\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive right labeled icon button"
  }, [_vm._v("\n      Yep, that's me\n      "), _c('i', {
    staticClass: "checkmark icon"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51da782b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/SignIn.vue
// module id = 8
// module chunks = 1 2 4